// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__21djS","rootCenter":"LoadMoreObserver_rootCenter__1FJdD","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__QghxB"};